<div [class]="'col' + (!props.readonly && props.editFieldStyleClass ? ' ' + props.editFieldStyleClass : '')">
  <new-ui-editor
    [formControl]="$any(formControl)"
    [formlyAttributes]="field"
    [lang]="props.language"
    [label]="props.label"
    [readonly]="props.readonly"
    [required]="props.required"
    [suggested]="formControl | isSuggested | async"
    [filledByAI]="formControl | isFilledByAI | async"
    [maxLength]="props.maxLength"
    [contentControl]="getContentControl()"
    [deltaControl]="getDeltaControl()"
    [dt]="props.dt"
    [propertyPath]="props.propertyPath"
  />

  @if (!props.readonly && props.hint) {
    <p-message [dt]="props.dt?.components?.message" severity="info" variant="simple" size="small">
      {{ props.hint }}
    </p-message>
  }

  @if (showError) {
    <p-message [dt]="props.dt?.components?.message" severity="error" variant="simple" size="small">
      <formly-validation-message [field]="field" />
    </p-message>
  }
</div>
